import type { Path, UseFormReturn } from 'react-hook-form';
import { Disclosure, DisclosureButton, Labeled, Switch } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IGeneralSettingsFormValues } from './GeneralSettingsForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';

export type IGeneralSettingsFormMiscSectionProps = IContainerProps & {
  form: UseFormReturn<IGeneralSettingsFormValues>;
  submittingFields?: Array<Path<IGeneralSettingsFormValues>>;
  onChange?: (
    form: UseFormReturn<IGeneralSettingsFormValues>,
    updatedFields?: Array<Path<IGeneralSettingsFormValues>>,
  ) => void;
};

export const GeneralSettingsFormMiscSection: React.FC<
  IGeneralSettingsFormMiscSectionProps
> = ({ sx, form, submittingFields, onChange }) => {
  const { t } = useTranslation();

  return (
    <Disclosure
      sx={sx}
      trigger={
        <DisclosureButton>
          {t('GeneralSettingsFormMiscSection.title')}
        </DisclosureButton>
      }
    >
      <FormSection sub>
        <Labeled
          label={t(
            'GeneralSettingsFormMiscSection.field.chatNotificationsEnabled.label',
          )}
          labelPosition="right"
          disabled={!form.watch('chatEnabled')}
        >
          <FormField
            name="chatNotificationsEnabled"
            control={form.control}
            as={Switch}
            rules={{
              onChange: () => onChange?.(form, ['chatNotificationsEnabled']),
            }}
            loading={submittingFields?.includes('chatNotificationsEnabled')}
          />
        </Labeled>
        <Labeled
          label={t(
            'GeneralSettingsFormMiscSection.field.displayTabsNames.label',
          )}
          labelPosition="right"
        >
          <FormField
            name="displayTabsNames"
            control={form.control}
            as={Switch}
            rules={{
              onChange: () => onChange?.(form, ['displayTabsNames']),
            }}
            loading={submittingFields?.includes('displayTabsNames')}
          />
        </Labeled>
      </FormSection>
    </Disclosure>
  );
};
